exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-wrapper[data-v-4d2a815e]{overflow:hidden!important;height:100%!important;padding-bottom:0!important}.active-conversation[data-v-4d2a815e]{background:linear-gradient(90deg,#000,#000 0,transparent 97%,transparent 0);border-radius:7px}", ""]);

// exports
